var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1764 10.3462C16.2117 10.0516 16.2353 9.74524 16.2353 9.42708C16.2353 9.10892 16.2117 8.80254 16.1646 8.50794L18.1561 6.95247C18.3328 6.81107 18.38 6.55182 18.2739 6.3515L16.3885 3.08737C16.2707 2.87526 16.0232 2.80456 15.8111 2.87526L13.4661 3.81797C12.9712 3.44088 12.4527 3.1345 11.8753 2.89883L11.5218 0.400651C11.4864 0.164974 11.2861 0 11.0504 0H7.27958C7.04391 0 6.85537 0.164974 6.82001 0.400651L6.4665 2.89883C5.88909 3.1345 5.35882 3.45267 4.87568 3.81797L2.53069 2.87526C2.31858 2.79277 2.07112 2.87526 1.95329 3.08737L0.0678695 6.3515C-0.049969 6.5636 -0.00283344 6.81107 0.185708 6.95247L2.17718 8.50794C2.13004 8.80254 2.09469 9.1207 2.09469 9.42708C2.09469 9.73346 2.11826 10.0516 2.16539 10.3462L0.173924 11.9017C-0.00283372 12.0431 -0.049969 12.3023 0.0560856 12.5027L1.9415 15.7668C2.05934 15.9789 2.3068 16.0496 2.51891 15.9789L4.8639 15.0362C5.35882 15.4133 5.87731 15.7197 6.45472 15.9553L6.80823 18.4535C6.85537 18.6892 7.04391 18.8542 7.27958 18.8542H11.0504C11.2861 18.8542 11.4864 18.6892 11.51 18.4535L11.8635 15.9553C12.4409 15.7197 12.9712 15.4015 13.4543 15.0362L15.7993 15.9789C16.0114 16.0614 16.2589 15.9789 16.3767 15.7668L18.2621 12.5027C18.38 12.2906 18.3328 12.0431 18.1443 11.9017L16.1764 10.3462ZM9.165 12.9622C7.22067 12.9622 5.62985 11.3714 5.62985 9.42708C5.62985 7.48274 7.22067 5.89192 9.165 5.89192C11.1093 5.89192 12.7002 7.48274 12.7002 9.42708C12.7002 11.3714 11.1093 12.9622 9.165 12.9622Z",
    fill: "url(#paint0_linear_771_8304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_771_8304",
    x1: 9.165,
    y1: 0,
    x2: 9.165,
    y2: 18.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#F95F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#942A2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.a06a5a2b4c2aec836af362d508133c24.svg";
export { ForwardRef as ReactComponent };